var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerYrkerLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.67,107.92h0a.8.8,0,0,1-.56-.24L13.2,95.78a.8.8,0,0,1,0-1.13L89.29,18.56a.82.82,0,0,1,1.13,0l11.9,11.91a.79.79,0,0,1,0,1.13L26.24,107.68A.8.8,0,0,1,25.67,107.92ZM14.9,95.21,25.67,106l75-75L89.86,20.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.74,107.92a8.31,8.31,0,0,1-5.92-2.45L63.71,76.36l1.13-1.13L94,104.34a6.78,6.78,0,0,0,9.58,0,6.8,6.8,0,0,0,0-9.59l-29-29,1.13-1.13,29,29a8.38,8.38,0,0,1-5.92,14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.56,57.53l-6.9-6.9a1.77,1.77,0,0,0-1.86-.38c-7.73,2.68-15.28,1.09-20.73-4.35A21,21,0,0,1,9.25,27.32a3.24,3.24,0,0,1,2.26-2.55,3.33,3.33,0,0,1,3.37.82l8.46,8.46a1.73,1.73,0,0,0,2.44,0l7.15-7.14a1.73,1.73,0,0,0,0-2.44L24.47,16a3.33,3.33,0,0,1-.82-3.37,3.23,3.23,0,0,1,2.55-2.26,21,21,0,0,1,18.57,5.82c5.45,5.45,7,13,4.35,20.73a1.79,1.79,0,0,0,.38,1.86l6.9,6.9-1.13,1.13-6.9-6.9a3.38,3.38,0,0,1-.76-3.51c2.48-7.13,1-14.08-4-19.08a19.46,19.46,0,0,0-17.16-5.38,1.73,1.73,0,0,0-.88,2.93l8.46,8.47a3.34,3.34,0,0,1,0,4.7l-7.15,7.14a3.32,3.32,0,0,1-4.7,0l-8.46-8.46A1.73,1.73,0,0,0,12,26.3a1.65,1.65,0,0,0-1.17,1.31A19.44,19.44,0,0,0,16.2,44.77c5,5,12,6.44,19.07,4a3.36,3.36,0,0,1,3.52.76l6.9,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.15,85.53a.76.76,0,0,1-.56-.23.8.8,0,0,1,0-1.13l52-52a.8.8,0,0,1,1.13,1.13l-52,52A.78.78,0,0,1,36.15,85.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.76,31.83a.71.71,0,0,1-.32-.07.79.79,0,0,1-.41-1.05L106.11,19l-4.27-4.28L90.15,19.83a.81.81,0,0,1-1.06-.41.8.8,0,0,1,.42-1.05l18.75-8.21.12,0a2,2,0,0,1,1.93.53,2,2,0,0,1,.53,1.92.65.65,0,0,1,0,.13l-8.31,18.66A.78.78,0,0,1,101.76,31.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,99.57a.79.79,0,0,1-.56-.24L21.56,87.42a.8.8,0,0,1,0-1.13.79.79,0,0,1,1.13,0L34.61,98.2A.81.81,0,0,1,34,99.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.12,102.73a3.53,3.53,0,1,1,2.5-6h0a3.53,3.53,0,0,1-2.5,6Zm0-5.46a2,2,0,0,0-1.37.56,2,2,0,1,0,1.37-.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerYrkerLarge);
export default __webpack_public_path__ + "static/media/Ikoner_Yrker_large.04335825e4f187ad97632f8214c7f23b.svg";
export { ForwardRef as ReactComponent };